/**
 * @file 定义全局状态管理
 */
export const store = {
  sounds: [{}, {}],
};

export const reducer = (state, action) => {
  const { type, data } = action;
  switch (type) {
    case 'initSounds':
      return {
        ...state,
        sounds: data,
      };
    default:
      throw new Error(`Unknown action: ${type}`);
  }
};

export const dispatch = reducer;
